import { c as r, a, i as c } from "./caml_exceptions-99f2c2ac.mjs";

var t = r("Promise.JsError");

function $$catch(r, s) {
  return r.catch((function(r) {
    return a(s, c(r) ? r : {
      RE_EXN_ID: t,
      _1: r
    });
  }));
}

export { $$catch as $, t as J };
